import { useState } from 'react';

interface InlineNumberInputProps {
  value: number;
  type: 'percent' | 'dollars';
  label?: string;
  onChange: (value: number) => void;
}

export default function InlineNumberInput({ value, type, label, onChange }: InlineNumberInputProps) {
  const [localValue, setLocalValue] = useState(String(type === 'dollars' ? value / 100 : value));

  const handleBlur = () => {
    const num = parseFloat(localValue);
    if (isNaN(num) || num < 0) {
      setLocalValue(String(type === 'dollars' ? value / 100 : value));
      return;
    }
    if (type === 'percent') {
      const clamped = Math.min(100, num);
      onChange(clamped);
      setLocalValue(String(clamped));
    } else {
      onChange(Math.round(num * 100));
      setLocalValue(String(num));
    }
  };

  return (
    <span className="inline-input">
      {type === 'dollars' && <span className="inline-input__prefix">$</span>}
      <input
        className="inline-input__field"
        type="number"
        min={0}
        max={type === 'percent' ? 100 : undefined}
        step={1}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={(e) => { if (e.key === 'Enter') (e.target as HTMLInputElement).blur(); }}
      />
      {type === 'percent' && <span className="inline-input__suffix">%</span>}
      {label && <span className="inline-input__label">{label}</span>}
    </span>
  );
}
